import { PlausibleProvider } from "@/providers/PlausibleProvider";
import "@/styles/globals.scss";
import Head from "next/head";
import ModalPopUp from "@/components/ModalPopUp/ModalPopUp";
import CustomReferralPopup from "@/components/CustomReferralPopup";
import { useMemo } from "react";
import mixpanel from 'mixpanel-browser';

export default function App({ Component, pageProps }) {
  // Add Page view event.
  // const router = useRouter();
  // const initialPageViewDone = useRef(false);
  // const handleRouteChange = (url) => {
  //   window.dataLayer.push({
  //     event: "page_view",
  //     page: url,
  //   });
  // };

  useMemo(() => {
    // Initialize Mixpanel asynchronously after page load to reduce bundle size
    mixpanel.init("083ee5baaf9e006ed67bacc6317074a2", {
      autotrack: true,
      autocapture: true,
      debug: typeof window !== 'undefined' && window.location.hostname !== 'localhost',
      record_sessions_percent: 3,
      record_heatmap_data: true,
      record_mask_text_selector: "",
      record_block_selectors: "",
      record_canvas: true,
    });
  }, []);

  // useEffect(() => {
  //   if (!initialPageViewDone.current) {
  //     initialPageViewDone.current = true;
  //     // handleRouteChange(window.location.pathname);
  //   }

  //   router.events.on("routeChangeComplete", handleRouteChange);
  //   return () => {
  //     router.events.off("routeChangeComplete", handleRouteChange);
  //   };
  // }, [router.events]);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="initial-scale=1.0, width=device-width, maximum-scale=5"
        />
        {/* {process.env.NEXT_PUBLIC_FACEBOOK_META_CONTENT && (
          <meta
            name="facebook-domain-verification"
            content={`${process.env.NEXT_PUBLIC_FACEBOOK_META_CONTENT}`}
          />
        )} */}
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`https://dt8esguquqvs0.cloudfront.net/assets/favicons/16x16.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`https://dt8esguquqvs0.cloudfront.net/assets/favicons/32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="180x180"
          href={`https://dt8esguquqvs0.cloudfront.net/assets/favicons/180x180.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="192x192"
          href={`https://dt8esguquqvs0.cloudfront.net/assets/favicons/192x192.png`}
        />
      </Head>
      {/* <GoogleTagManager gtmId={`${process.env.NEXT_PUBLIC_GTM_ID}`} /> */}
        <PlausibleProvider>
          <Component {...pageProps} />
          <ModalPopUp />
          {/* <ReferralPopup /> */}
          <CustomReferralPopup />
        </PlausibleProvider>
    </>
  );
}
